import React from 'react';
import { string, array } from 'prop-types';
import { isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { Heading } from '@fiverr-private/typography';
import { Stack, Container } from '@fiverr-private/layout_components';
import { translationKeyWithLocale } from '../../../lib/translation/translationKeyWithLocale';
import { TagLink } from '../TagLink';

export const RelatedLinks = ({ relatedLinks = [], name }) => {
    const { locale, isTouch } = getContext();

    const translatedHeader = translationKeyWithLocale({
        k: 'tag_page_perseus.related_links.title',
        params: { name },
        locale,
    });

    if (isEmpty(relatedLinks)) {
        return null;
    }

    return (
        <Container
            as="section"
            display="flex"
            justifyContent="center"
            alignItems="center"
            direction="column"
            paddingBottom="0"
            paddingTop={isTouch ? '4' : '8'}
            borderColor="grey_500"
            borderTopWidth="sm"
        >
            <Heading as="h2" size={{ default: 'h_lg', sm: 'h_xl' }} paddingBottom="8" textAlign="center">
                {translatedHeader}
            </Heading>
            <Stack wrap="wrap" justifyContent="center" width="60%" alignSelf="center" columnGap="4" rowGap="4">
                {relatedLinks.map((tag) => (
                    <TagLink key={tag.slug} {...tag} />
                ))}
            </Stack>
        </Container>
    );
};

RelatedLinks.propTypes = {
    relatedLinks: array,
    name: string,
};

export default RelatedLinks;
